import CircularProgress from '@mui/material/CircularProgress';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import {
  addOneRedirectNoBimmo,
  addOneSeenNoBimmo,
  /*favorite,*/ getAddressMap,
  getProperties,
  getPropertyNoBimmo,
} from '../api';
import Button from '../components/core/Button';
import List from '../components/core/List';
import Map from '../components/Map';
import { Property as RelatedProperty } from '../components/Property/Property';
import ShareDialog from '../components/ShareDialog';
//import { getPercentages } from '../helpers/percentages';
import { getFormattedPrice } from '../helpers/price';
import { getLocaleDate } from '../helpers/time';
import { getSingularPluralWord } from '../i18n/translations';
//import { useGlobalContext } from '../stores/global';
import styles from './PropertyNoBimmo.module.scss';
import Resize from '../images/icons/resize.svg';
import NoImage from '../images/noimage-placeholder.png';
import casaDefault from '../images/casaDefault.jpg';
import apartamentoDefault from '../images/apartamentoDefault.jpg';
import loteDefault from '../images/loteDefault.jpg';
import edificioDefault from '../images/edificioDefault.jpg';
import localDefault from '../images/localDefault.jpg';
import apartaestudioDefault from '../images/apartaestudioDefault.jpg';

import { Tooltip } from '@mui/material';
import moment from 'moment';
import { useGlobalContext } from '../stores/global';
import { Alert } from '@mui/material';
import { Link } from 'react-router-dom';

interface Props {
  match: any;
}

interface DocList {
  docs: any[];
  page: number;
  pagingCounter: number;
  limit: number;
  totalPages: number;
  totalDocs: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  nextPage: number;
  prevPage: number;
}

/* function getPieChartValues(property: any) {
  const items = [
    { title: 'Internet', value: 113900, bg: '#CEA944' },
    { title: 'Gas natural', value: 29467, bg: '#6549AB' },
    { title: 'Agua', value: 43060, bg: '#3ECC88' },
    { title: 'Luz', value: 72654, bg: '#DB3F48' },
  ];

  if (property?.adminPrice) {
    items.unshift({
      title: 'Administración',
      value: Number(property?.adminPrice),
      bg: '#3584CE',
    });
  }

  const { parsedItems, total } = getPercentages(items);

  return {
    formattedTotalPrice: getFormattedPrice(total),
    parsedItems: parsedItems.map((el) => ({
      ...el,
      formattedPrice: getFormattedPrice(el.value),
    })),
  };
} */

/* function SlideShow(props: {
  idx?: number;
  images: any[];
  onClose?: () => void;
}) {
  if (typeof props.idx === 'undefined') return null;

  return (
    <MaterialModal
      open
      className={styles.slideshowModal}
      onBackdropClick={props.onClose}
      onEscapeKeyDown={props.onClose}
    >
      <div className={styles.slideshowContainer}>
        <button className={styles.slideshowCloseBtn} onClick={props.onClose}>
          <i className="fonticons fonticons-x" />
        </button>

        <Swiper
          keyboard={{ enabled: true }}
          className={styles.slideshowSwiper}
          pagination={{ type: 'fraction' }}
          loop
          initialSlide={props.idx}
          navigation
          zoom
        >
          {props.images.map((image, idx) => (
            <SwiperSlide key={idx} onClick={props.onClose}>
              <div className="swiper-zoom-container">
                <img
                  src={getImageUrl(image)}
                  onClick={(e) => e.stopPropagation()}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </MaterialModal>
  );
}
 */
export default function PropertyNoBimmo(props: Props) {
  const { user, dispatch } = useGlobalContext();
  const [property, setProperty] = useState<any>();
  //const [slideshowIdx, setslideshowIdx] = useState<number>();
  const [properties, setProperties] = useState<DocList>();
  const [error, setError] = useState<string>();
  const [bar, setBar] = useState(false);
  //const [slide, setSlide] = useState(0);
  const [showShareDialog, setShowShareDialog] = useState(false);
  const [isFavorite, setFavorite] = useState(false);
  const [avgPrices, setAvgPrices] = useState<any[]>([]);
  //const { dispatch } = useGlobalContext();
  /*const [pieChartValues, setPieChartValues] = useState<
    ReturnType<typeof getPieChartValues>
  >();*/

  const getAvgPrice = (neighborhood: string, propertyType: string) => {
    // Cuadrar para tildes
    let res = avgPrices.filter((item: any) => {
      if (item._id.neighborhood && item._id.propertyType) {
        return (
          item._id?.neighborhood
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '') ===
            neighborhood
              .toLowerCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '') &&
          item._id?.propertyType
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '') ===
            propertyType
              .toLowerCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
        );
      }
    });
    return getFormattedPrice(res[0]?.avg.toFixed(2) || 0);
  };

  const getAvgPriceNumber = (neighborhood: string, propertyType: string) => {
    let res = avgPrices.filter((item: any) => {
      if (item._id.neighborhood && item._id.propertyType) {
        return (
          item._id?.neighborhood
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '') ===
            neighborhood
              .toLowerCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '') &&
          item._id?.propertyType
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '') ===
            propertyType
              .toLowerCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
        );
      }
    });
    return res[0].avg.toFixed(2) || 0;
  };

  const getResultAnalitics = (priceMtsSq: number, avgMtsSq: number) => {
    if (priceMtsSq - avgMtsSq > 1) {
      let percent = ((priceMtsSq / avgMtsSq) * 100 - 100).toFixed(1);
      return `Precio <span class=${
        user?.name ? styles.showTextBad : styles.blurInformationBest
      }>${user?.name ? percent : 0}% mayor</span>  que el precio promedio en ${
        property.neighborhood
      }`;
    } else {
      if (priceMtsSq - avgMtsSq < -1) {
        let percent = ((avgMtsSq / priceMtsSq) * 100 - 100).toFixed(1);
        return `Precio <span class=${
          user?.name ? styles.showTextBest : styles.blurInformationBad
        }>${
          user?.name ? percent : 0
        }% menor</span>  que el precio promedio en ${property.neighborhood}`;
      } else {
        return `Precio en promedio del barrio ${property.neighborhood}`;
      }
    }
  };

  const openLogin = () => {
    dispatch({ type: 'SET_LOGIN_MODAL', payload: 'signin' });
  };

  useEffect(() => {
    getProperties().then((response) => {
      setAvgPrices(response.data.data?.avg);
      setProperties(response.data.data);
      addOneSeenNoBimmo(props.match.params.id);
      getPropertyNoBimmo(props.match.params.id)
        .then((response) => {
          const property = response.data.data;
          if (
            property.coordinates.lat < -4.227109899999999 ||
            property.coordinates.lat > 13.5177999 ||
            property.coordinates.lon < -81.8317 ||
            property.coordinates.lon > -66.8463122
          ) {
            /*  console.log('hola'); */
            getAddressMap(
              property.address
                ? property.address + ' ' + property.city
                : property.neighborhood + ' ' + property.city,
              'AIzaSyDZLvNkAJKuwNZQjB2pUkctJUzz6kdljdA'
            ).then((response) => {
              const data = response.data;
              /*  console.log(response.data); */
              if (data.status === 'OK' && data.results.length > 0) {
                property.coordinates.lat =
                  data.results[0].geometry.location.lat;
                property.coordinates.lon =
                  data.results[0].geometry.location.lng;
                setProperty(property);
              } else {
                setProperty(property);
              }
            });
          } else {
            setProperty(property);
          }
          setFavorite(!!response.data.data.favorite);
          //setPieChartValues(getPieChartValues(property));
        })
        .catch(() => setError('Ocurrió un error. Intentalo más tarde'));
    });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setBar(document.body.parentElement!.scrollTop >= 290);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  /* const handleFavorite = () => {
    favorite(property._id)
      .then((response) => setFavorite(!!response.data.data.added))
      .catch(openSigninOn401Error.bind(null, dispatch));
  }; */

  const goToLink = () => {
    addOneRedirectNoBimmo(props.match.params.id);
    window.open(property.link, '_blank');
  };

  if (error) {
    return <div>{error}</div>;
  }

  if (!property) {
    return (
      <div>
        <CircularProgress />
      </div>
    );
  }

  const favoriteEl = (
    <a onClick={() => /*handleFavorite()*/ {}}>
      {isFavorite ? (
        <i className="fonticons fonticons-heart-filled" />
      ) : (
        <i className="fonticons fonticons-heart" />
      )}
      <span className={styles.hiddeM}>Guardar</span>
    </a>
  );

  const shareEl = (
    <a onClick={() => setShowShareDialog(true)}>
      <i className="fonticons fonticons-share" />
      <span className={styles.hiddeM}>Compartir</span>
    </a>
  );

  const seen = (
    <a onClick={() => {}}>
      <i className="fonticons fonticons-eye" />
      <span>{property.seen}</span>
    </a>
  );

  const goToPropertiesClick = (
    <a onClick={() => {}}>
      <i className="fonticons fonticons-click" />
      <span>{property.redirect}</span>
    </a>
  );

  const dateInSpanish = (date: string) => {
    var localLocale = moment(date);
    moment.locale('es');
    localLocale.locale(false);
    return localLocale.fromNow();
  };

  return (
    <div className={styles.container}>
      <div className={clsx(styles.header, bar && styles.bar)}>
        <Link to="/properties">
          <i className="fonticons fonticons-arrow-left" />
        </Link>
        <div style={{ color: '#fff' }} className={styles.shortText}>
          <span>{property.title}</span>
        </div>
      </div>

      <div className={styles.propertyContainer}>
        <div className={styles.propertyMedia}>
          <div className={styles.imageGrid}>
            <Map
              zoom={16}
              draggable={false}
              options={{ fullscreenControl: false }}
              center={{
                lat: property.coordinates.lat,
                lng: property.coordinates.lon,
              }}
            />
            <i className="fonticons fonticons-pin" />
          </div>
        </div>
        <div className={styles.propertyInfo}>
          <div className={styles.propertyInfoTop}>
            <div className={styles.hiddeM}>
              <h2 className={styles.shortText}>
                <Tooltip title={property.title}>
                  <span>{property.title}</span>
                </Tooltip>
              </h2>
            </div>
            <div className={styles.desc}>
              <i className="fonticons fonticons-location" />{' '}
              <span>
                {(property?.address ? property?.address : '') +
                  ' ' +
                  property?.neighborhood +
                  ', ' +
                  property?.city}
              </span>
            </div>
            <div className={styles.title}>
              <span className={styles.price}>
                {getFormattedPrice(property.price)}
              </span>{' '}
              <span className={styles.details}>
                <b>
                  {property.rooms === 'Sin especificar' ? '-' : property.rooms}
                </b>{' '}
                {getSingularPluralWord('room', property.rooms)} |{' '}
                <b>
                  {property.bathrooms === 'Sin especificar'
                    ? '-'
                    : property.bathrooms}
                </b>{' '}
                {getSingularPluralWord('bathroom', property.bathrooms)} |{' '}
                <b>
                  {property.areaBuild > property.area
                    ? property.areaBuild
                    : property.area}
                </b>{' '}
                m<small>2</small>
              </span>
            </div>

            {/* <div className={styles.basicInfo}>
              <p>
                <i className="fonticons fonticons-bed" />
                <span>
                  {property.rooms}{' '}
                  <span style={{ textTransform: 'capitalize' }}>
                    {getSingularPluralWord('room', property.rooms)}
                  </span>
                </span>
              </p>
              <p>
                <i className="fonticons fonticons-bathtub" />
                <span>
                  {property.bathrooms}{' '}
                  <span style={{ textTransform: 'capitalize' }}>
                    {getSingularPluralWord('bathroom', property.bathrooms)}
                  </span>
                </span>
              </p>
              <p>
                <i className="fonticons fonticons-area" />
                <span>
                  {property.areaBuild}m<small>2</small>
                </span>
              </p>
              <p>
                <i className="fonticons fonticons-building" />
                {property.age ? (
                  <span>Construido en {property.age}</span>
                ) : (
                  <span>Entrega: {getLocaleDate(property?.deliverDate)}</span>
                )}
              </p>
              <p>
                <i className="fonticons fonticons-car" />
                <span>
                  {property.garages}{' '}
                  <span style={{ textTransform: 'capitalize' }}>
                    {getSingularPluralWord('parking', property.garages)}
                  </span>
                </span>
              </p>
              <p>
                <i className="fonticons fonticons-home2" />
                <span>Estrato {property.stratum}</span>
              </p>
            </div> */}

            <div className={styles.rowBtns}>
              <div>
                {favoriteEl}
                {shareEl}
                {seen}
                {goToPropertiesClick}
              </div>
              <Button
                iconUrl={Resize}
                className={styles.buttonChat}
                spanProps={{ className: styles.labelBtn }}
                onClick={goToLink}
                label="IR A PROPIEDAD"
              />
            </div>
          </div>

          <div className={styles.propertyInfoBottom}>
            <div style={{ textAlign: 'center' }}>
              <img
                className={styles.noimage2}
                src={
                  property.propertyType === 'Casa'
                    ? casaDefault
                    : property.propertyType === 'Apartamento'
                    ? apartamentoDefault
                    : property.propertyType === 'Lote'
                    ? loteDefault
                    : property.propertyType === 'Edificio'
                    ? edificioDefault
                    : property.propertyType === 'Local'
                    ? localDefault
                    : property.propertyType === 'Apartaestudio'
                    ? apartaestudioDefault
                    : NoImage
                }
                alt="No image"
              />
            </div>
            <div>
              <i className="fonticons fonticons-calendar" />{' '}
              <span>
                Publicado{' '}
                {dateInSpanish(
                  property?.dates?.created
                    ? property?.dates?.created
                    : property.createdAt
                )}
              </span>
            </div>

            <h3>Descripción</h3>
            <p>{property.description}</p>
            {!user?.name ? (
              <Tooltip title={'Inicia sesión para ver toda la información'}>
                <>
                  <h3>Análisis de la propiedad</h3>
                  {!user?.name && (
                    <Alert
                      onClick={() => openLogin()}
                      style={{
                        marginBottom: '10px',
                        fontSize: '14px',
                        cursor: 'pointer',
                      }}
                      severity="info"
                    >
                      <strong>Inicia sesión</strong> para ver toda la
                      información
                    </Alert>
                  )}
                  <div className={styles.blurInformation}>
                    <p>
                      <strong>
                        {' '}
                        Precio promedio metro cuadrado del barrio:{' '}
                      </strong>
                      {getAvgPrice(
                        property.neighborhood,
                        property.propertyType
                      )}
                    </p>

                    <div
                      dangerouslySetInnerHTML={{
                        __html: getResultAnalitics(
                          parseFloat(property.price) /
                            parseFloat(
                              property.areaBuild > property.area
                                ? property.areaBuild
                                : property.area
                            ),
                          getAvgPriceNumber(
                            property.neighborhood,
                            property.propertyType
                          )
                        ),
                      }}
                    ></div>
                  </div>
                </>
              </Tooltip>
            ) : (
              <>
                <h3>Análisis de la propiedad</h3>
                <p>
                  <strong>
                    {' '}
                    Precio promedio metro cuadrado en {
                      property.neighborhood
                    }:{' '}
                  </strong>
                  {getAvgPrice(property.neighborhood, property.propertyType)}
                </p>

                <div
                  dangerouslySetInnerHTML={{
                    __html: getResultAnalitics(
                      parseFloat(property.price) /
                        parseFloat(
                          property.areaBuild > property.area
                            ? property.areaBuild
                            : property.area
                        ),
                      getAvgPriceNumber(
                        property.neighborhood,
                        property.propertyType
                      )
                    ),
                  }}
                ></div>
              </>
            )}
            <h3>Detalles de la propiedad</h3>
            <ul className={styles.details}>
              <li>
                <span>Precio de venta</span>
                <span>{getFormattedPrice(property.price)}</span>
              </li>
              <li>
                <span>Tipo de propiedad</span>
                <span>{property.propertyType}</span>
              </li>
              <li>
                <span>Ciudad</span>
                <span>{property.city}</span>
              </li>
              <li>
                <span>Departamento</span>
                <span>{property?.state ? property?.state : '-'}</span>
              </li>
              <li>
                <span>Área construida</span>
                <span>
                  {property.areaBuild > property.area
                    ? property.areaBuild
                    : property.area}{' '}
                  m<small>2</small>
                </span>
              </li>
              <li>
                <span>Alcobas</span>
                <span>
                  {property.rooms === 'Sin especificar' ? '-' : property.rooms}
                </span>
              </li>
              <li>
                <span>Baños</span>
                <span>
                  {property.bathrooms === 'Sin especificar'
                    ? '-'
                    : property.bathrooms}
                </span>
              </li>
              <li>
                <span>Parqueaderos</span>
                <span>
                  {property.garages === 'Sin especificar'
                    ? '-'
                    : property.garages}
                </span>
              </li>
              <li>
                <span>Estrato</span>
                <span>{property.stratum}</span>
              </li>
              <li>
                {property.age ? (
                  <>
                    <span>Año de construcción</span>
                    <span>{property.age}</span>
                  </>
                ) : (
                  <>
                    <span>Fecha de entrega</span>
                    <span>{getLocaleDate(property?.deliverDate)}</span>
                  </>
                )}
              </li>
              <li>
                <span>Precio Metro cuadrado</span>
                <span>
                  {getFormattedPrice(
                    (
                      parseFloat(property.price) /
                      parseFloat(
                        property.areaBuild > property.area
                          ? property.areaBuild
                          : property.area
                      )
                    ).toFixed(0)
                  ).replace('$', '') + ' '}
                  $/m²
                </span>
              </li>
              {property.adminPrice ? (
                <li>
                  <span>Administración</span>
                  <span>{getFormattedPrice(property.adminPrice)}</span>
                </li>
              ) : null}
              {property.floor !== 'Sin especificar' ? (
                <li>
                  <span>Piso N°</span>
                  <span>{property.floor}</span>
                </li>
              ) : null}
            </ul>
            <h3>Características</h3>
            <ul className={styles.features}>
              {property.featured
                .sort(function (a: any, b: any) {
                  return b.items.length - a.items.length;
                })
                .map((item: any) => {
                  if (item.items.length > 0)
                    return (
                      <li key={item.title}>
                        <span className={styles.featureTitle}>
                          {item.title}
                        </span>
                        <ul>
                          {item.items.map((feature: any) => (
                            <li key={feature}>
                              <i className="fonticons fonticons-checked" />
                              <span>{feature}</span>
                            </li>
                          ))}
                        </ul>
                      </li>
                    );
                })}
            </ul>

            <h3 className={styles.onlyMobile}>Ubicación de la propiedad</h3>
            <div className={styles.mapContainer}>
              <Map
                zoom={14}
                draggable={false}
                options={{ fullscreenControl: false }}
                center={{
                  lat: property.coordinates.lat,
                  lng: property.coordinates.lon,
                }}
              />
              <i className="fonticons fonticons-pin" />
            </div>

            {/* <h3>Gastos mensuales</h3>
            <div className={styles.pieContainer}>
              <div className={styles.pieContent}>
                <div className={styles.pie}>
                  {pieChartValues?.parsedItems.map((el, idx) => (
                    <div
                      key={idx}
                      className={styles.pieSegment}
                      style={
                        {
                          '--pieChartOffset':
                            idx > 0 ? el.cumulPercRounded - el.percRounded : 0,
                          '--pieChartValue': el.percRounded,
                          '--pieChartBg': el.bg,
                          '--pieChartOver50':
                            el.percRounded >= 50 ? 1 : undefined,
                        } as CSSProperties
                      }
                    />
                  ))}

                  <div className={styles.pieTotalInfo}>
                    <p>Total gastos</p>
                    <span>{pieChartValues?.formattedTotalPrice}**</span>
                    <p>Mensuales</p>
                  </div>
                </div>

                <div className={styles.pieItems}>
                  {pieChartValues?.parsedItems.map((el, idx) => (
                    <div key={idx}>
                      <p>
                        <span style={{ backgroundColor: el.bg }} />
                        {el.title}
                      </p>
                      <span>{el.formattedPrice}</span>
                    </div>
                  ))}
                </div>
              </div>
              <p className={styles.pieFooter}>
                **La gráfica muestra valores aproximados a los precios
                encontrados en la
                <b> Superintendencia de Servicios Públicos Domiciliarios. </b>No
                indica la fracción que corresponde a la cuota mensual
                financiada.
              </p>
            </div> */}

            {properties && false ? (
              <>
                <h3>Otras propiedades similares</h3>
                <div className={styles.relatedProperties}>
                  <List className={styles.relatedPropertiesList}>
                    {properties?.docs.map(
                      (property) =>
                        !property.idWebSite && (
                          <RelatedProperty
                            property={property}
                            key={`related-${property.id}`}
                          />
                        )
                    )}
                    <div style={{ width: 10 }} />
                  </List>
                </div>
              </>
            ) : null}
          </div>
        </div>
      </div>

      <ShareDialog
        url={window.location.href}
        open={showShareDialog}
        onClose={() => setShowShareDialog(false)}
      />

      {/* <SlideShow
        idx={slideshowIdx}
        images={propertyImages}
        onClose={() => setslideshowIdx(undefined)}
      /> */}
    </div>
  );
}
